import { PeriodSeqComboBoxModel } from '../period-seq-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * 受注コード期間マスタリストを取得する
 *
 * @export API通信成功時の処理
 * @class GetPeriodSeqListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetPeriodSeqListService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: PeriodSeqComboBoxModel;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param {PeriodSeqboBoxModel} model
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof PeriodSeqComboBoxService
   */
  execute(model: PeriodSeqComboBoxModel, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('KYMW02getPeriodSeqList', null);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPeriodSeqListService
   */
  success(data: any) {
    this.model.updateCodeList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
